import { CmsPageModuleContent, CmsPageModuleType } from '@ndvr/cms-api';

const CMS_MODULE_PICKER_ORDER: CmsPageModuleType[] = [
    CmsPageModuleType.HERO,
    CmsPageModuleType.ADVISOR_PROFILE,
    CmsPageModuleType.MEDIA_TEXT_SECTION,
    CmsPageModuleType.INFO_CARD_GRID,
    CmsPageModuleType.PROCESS_STEPS,
    CmsPageModuleType.QUOTE_SECTION,
    CmsPageModuleType.RESOURCE_LIST,
    CmsPageModuleType.IMPORTANT_DISCLOSURES,
    CmsPageModuleType.CONTACT_SECTION,
    CmsPageModuleType.LEAD_FORM,
    CmsPageModuleType.FAQ,
    CmsPageModuleType.CTA,
];

const REPEATABLE_MODULE_TYPES = new Set<CmsPageModuleType>([
    CmsPageModuleType.HERO,
    CmsPageModuleType.MEDIA_TEXT_SECTION,
    CmsPageModuleType.INFO_CARD_GRID,
    CmsPageModuleType.PROCESS_STEPS,
    CmsPageModuleType.QUOTE_SECTION,
    CmsPageModuleType.RESOURCE_LIST,
    CmsPageModuleType.CTA,
]);
const REQUIRED_MODULE_COUNTS: Partial<Record<CmsPageModuleType, number>> = {};

export const isRepeatableCmsModuleType = (type: CmsPageModuleType): boolean => REPEATABLE_MODULE_TYPES.has(type);

export const isRequiredCmsModuleType = (type: CmsPageModuleType): boolean => (REQUIRED_MODULE_COUNTS[type] ?? 0) > 0;

export const slugifyAdvisorDisplayName = (displayName: string): string =>
    displayName
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

export const getCmsModuleInstanceKey = (module: CmsPageModuleContent, index: number): string => {
    return module.cmsPageModuleGUID == null ? `${module.moduleType}-${index}` : String(module.cmsPageModuleGUID);
};

export const getAddableCmsModuleTypes = (modules: CmsPageModuleContent[]): CmsPageModuleType[] =>
    CMS_MODULE_PICKER_ORDER.filter(
        (type) => REPEATABLE_MODULE_TYPES.has(type) || !modules.some((module) => module.moduleType === type),
    );

export const canRemoveCmsModule = (modules: CmsPageModuleContent[], index: number): boolean => {
    const module = modules[index];
    if (!module) {
        return false;
    }
    const requiredCount = REQUIRED_MODULE_COUNTS[module.moduleType] ?? 0;
    const currentCount = modules.filter((candidate) => candidate.moduleType === module.moduleType).length;

    return currentCount > requiredCount;
};

export const getCmsModuleDisplayTitle = (modules: CmsPageModuleContent[], index: number): string => {
    const module = modules[index];
    if (!module) {
        return 'Section';
    }
    const sameTypeCount = modules.filter((candidate) => candidate.moduleType === module.moduleType).length;
    if (sameTypeCount <= 1) {
        return module.moduleType;
    }
    const occurrence = modules
        .slice(0, index + 1)
        .filter((candidate) => candidate.moduleType === module.moduleType).length;

    return `${module.moduleType} ${occurrence}`;
};
